// src/components/RegisterAnimation.js
import React from "react";
import Lottie from "lottie-react";
import animationData from "../animations/training.json";

function RegisterAnimation() {
  return (
    <div style={{ width: "100%", maxWidth: 500, margin: "0 auto" }}>
      <Lottie animationData={animationData} loop={true} />
    </div>
  );
}

export default RegisterAnimation;
